"use client"

import { useIsAuthen } from "@/hooks/auth/useIsAuthen"
import { useAppSelector } from "@/lib/redux/hooks"
import { Modal } from "antd"
import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react"
import ListPendingOrders from "./ListPendingOrders"
import { useTranslation } from "react-i18next"

export type ModalPendingOrdersRef = {
  open: () => void,
  close: () => void
}

let timeoutOpen: any = null

const ModalPendingOrders = forwardRef<ModalPendingOrdersRef, any>((props, ref) => {
  const pendingOrders = useAppSelector(state => state.booking.pendingOrders)
  const isAuthen = useIsAuthen()
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [
    handleClose,
    handleOpen
  ])

  useEffect(() => {
    if (timeoutOpen) return;
    if (timeoutOpen) {
      clearTimeout(timeoutOpen)
    }
    if (pendingOrders.length > 0) {
      timeoutOpen = setTimeout(() => {
        setOpen(true)
      }, 800)
    } else {
      setOpen(false)
    }
  }, [pendingOrders])

  return (
    <Modal
      open={open && !isAuthen}
      title={t("profile.pending_orders_title")}
      okText={t("common.undertood")}
      cancelText={t("common.close")}
      width={"70rem"}
      onCancel={handleClose}
      footer={<></>}
    >
      <ListPendingOrders />
    </Modal>
  )
})

export default ModalPendingOrders